module.exports = __webpack_public_path__ + "static/media/offers_active.e123a61b.svg";